<script setup lang="ts">
  import ManagerToast from '@/components/Global/Manager/ManagerToast.vue'
</script>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'TheDefaultFluidLayout',
  })
</script>

<template>
  <main class="w-full">
    <slot />
  </main>

  <ManagerToast />
</template>
